module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/mobile-81aaf0d2677bd0aa0a898a88ab949d65.webp";